/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';

const NotFound = () => {

    return (

        <div className='loader-error'>

            <span className='material-icons'>
                info
            </span>

            Page can't be found.
            <br/><br/>
        </div>

    )

}

export default NotFound;
